/* Mon Livre de Vie v8 — visible poster first; no MP4 request before activation.
   This script never changes prices, checkout, consent or analytics. */
(function () {
  'use strict';
  if (window.MLVMedia) return;
  var instances = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(root) {
    if (instances.has(root)) return;
    var trigger = root.querySelector('[data-mlv-play]');
    var image = root.querySelector('img');
    var status = root.querySelector('[data-mlv-media-status]');
    var src = window.matchMedia('(min-width: 990px)').matches && root.dataset.videoSrcDesktop ? root.dataset.videoSrcDesktop : root.dataset.videoSrc;
    if (!trigger || !src || !status) return;
    var video = null, timer = 0, busy = false, disposed = false, observer = null;
    var automatic = false, focusAfterPlay = false;
    var label = trigger.innerHTML;

    function say(message, direct) {
      status.replaceChildren();
      status.hidden = !message;
      if (!message) return;
      status.appendChild(document.createTextNode(message));
      if (direct) {
        var link = document.createElement('a');
        link.href = src;
        link.textContent = ' Ouvrir la vidéo directement';
        status.appendChild(link);
      }
    }
    function recover(message) {
      if (disposed) return;
      clearTimeout(timer);
      busy = false;
      root.classList.remove('is-loading', 'is-active', 'is-playing');
      root.removeAttribute('aria-busy');
      trigger.disabled = false;
      trigger.hidden = false;
      trigger.innerHTML = label;
      if (video) {
        var old = video;
        video = null; // Ignore events dispatched while aborting a failed source.
        old.pause();
        old.removeAttribute('src');
        old.load();
        old.remove();
      }
      if (focusAfterPlay) trigger.focus({preventScroll: true});
      say(message, true);
    }
    function activate(userInitiated) {
      if (disposed || busy) return;
      if (video && root.classList.contains('is-active')) {
        video.play().catch(function () { say('Appuyez sur le bouton de lecture du lecteur.', false); });
        return;
      }
      automatic = !userInitiated;
      focusAfterPlay = !!userInitiated;
      busy = true;
      trigger.disabled = true;
      trigger.hidden = true;
      root.setAttribute('aria-busy', 'true');
      root.classList.add('is-loading');
      say('Chargement de la vidéo…', false);
      var current = document.createElement('video');
      video = current;
      if (root.classList.contains('mlv16-media') && window.matchMedia('(min-width: 990px)').matches) {
        current.style.setProperty('width','100%','important');
        current.style.setProperty('height','auto','important');
        current.style.setProperty('aspect-ratio','16 / 9','important');
        current.style.setProperty('max-height','100%','important');
        current.style.setProperty('inset','auto','important');
        current.style.setProperty('top','50%','important');
        current.style.setProperty('left','50%','important');
        current.style.setProperty('transform','translate(-50%, -50%)','important');
        current.style.setProperty('object-fit','contain','important');
      }
      current.controls = true;
      current.playsInline = true;
      current.preload = 'none';
      current.crossOrigin = 'anonymous';
      current.muted = root.dataset.videoMuted === 'true';
      current.defaultMuted = current.muted;
      current.loop = root.dataset.videoLoop === 'true';
      current.tabIndex = 0;
      current.setAttribute('aria-label', root.dataset.videoLabel || 'Vidéo Mon Livre de Vie');
      if (image) current.poster = image.currentSrc || image.src;
      if (root.dataset.videoCaptions) {
        var track = document.createElement('track');
        track.kind = 'captions';
        track.srclang = 'fr';
        track.label = 'Français';
        track.src = root.dataset.videoCaptions;
        track.default = true;
        current.appendChild(track);
      }
      current.addEventListener('playing', function () {
        if (disposed || video !== current) return;
        clearTimeout(timer);
        busy = false;
        trigger.disabled = false;
        root.removeAttribute('aria-busy');
        root.classList.remove('is-loading');
        root.classList.add('is-active', 'is-playing');
        trigger.hidden = true;
        say('', false);
        document.querySelectorAll('[data-mlv-player] video').forEach(function (other) {
          if (other !== current && !other.paused) other.pause();
        });
        if (focusAfterPlay) {
          current.focus({preventScroll:true});
          focusAfterPlay = false;
        }
      });
      current.addEventListener('pause', function () { if (video === current) root.classList.remove('is-playing'); });
      current.addEventListener('ended', function () { if (video === current) root.classList.remove('is-playing'); });
      current.addEventListener('error', function () {
        if (video === current) recover('La vidéo n’a pas pu être chargée. Réessayez ou utilisez le lien direct.');
      });
      root.insertBefore(current, trigger);
      timer = setTimeout(function () {
        if (video === current && busy) recover('Le chargement prend trop de temps. Réessayez avec une connexion stable.');
      }, 20000);
      current.src = src;
      current.load();
      var playing = current.play();
      if (playing && playing.catch) playing.catch(function (error) {
        if (disposed || video !== current) return;
        recover(error && error.name === 'NotAllowedError'
          ? 'La lecture automatique a été refusée. Appuyez pour lire la vidéo.'
          : 'La vidéo n’a pas pu démarrer. Réessayez ou utilisez le lien direct.');
      });
    }
    function click() { activate(true); }
    trigger.addEventListener('click', click);
    function maybeAutoplay() { /* Activation uniquement au clic. */ }
    instances.set(root, {
      pause: function () { if (video && !video.paused) video.pause(); },
      pauseAutomatic: function () { if (automatic && video) video.pause(); },
      destroy: function () {
        disposed = true;
        clearTimeout(timer);
        trigger.removeEventListener('click', click);
        window.removeEventListener('load', maybeAutoplay);
        if (observer) observer.disconnect();
        if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
        instances.delete(root);
      }
    });
  }
  function init(container) {
    if (container.matches && container.matches('[data-mlv-player]')) mount(container);
    container.querySelectorAll('[data-mlv-player]').forEach(mount);
  }
  window.MLVMedia = {init:init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {init(document);}, {once:true});
  else init(document);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) instances.forEach(function (instance) { instance.pause(); });
  });
  reduced.addEventListener('change', function () {
    if (reduced.matches) instances.forEach(function (instance) { instance.pauseAutomatic(); });
  });
  document.addEventListener('shopify:section:load', function (e) {init(e.target);});
  document.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (instance, root) {if (e.target.contains(root)) instance.destroy();});
  });
}());
